import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Heart, ShoppingCart } from 'lucide-react';

const ProductCard = ({ product }) => {
    const navigate = useNavigate();
    const [isWishlisted, setIsWishlisted] = useState(false);

    return (
        <div
            className="group cursor-pointer bg-white border border-gray-100 hover:border-[#1B4965]/20 transition-all duration-300 rounded-sm overflow-hidden"
            style={{ fontFamily: "'Work Sans', sans-serif" }}
        >
            {/* Image Container */}
            <div
                className="relative overflow-hidden"
                style={{ paddingBottom: '133.33%' }}
                onClick={() => navigate(`/template4/product/${product.id}`)}
            >
                <img
                    src={product.image}
                    alt={product.name}
                    className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />

                {/* Badges */}
                {product.tag && (
                    <span className="absolute top-2 left-2 px-2 py-0.5 text-[10px] sm:text-xs font-semibold tracking-wider uppercase bg-[#1B4965] text-white rounded-sm">
                        {product.tag}
                    </span>
                )}
                {product.originalPrice && !product.tag && (
                    <span className="absolute top-2 left-2 px-2 py-0.5 text-[10px] sm:text-xs font-semibold tracking-wider uppercase bg-[#62B6CB] text-white rounded-sm">
                        SALE
                    </span>
                )}

                {/* Wishlist */}
                <button
                    onClick={(e) => {
                        e.stopPropagation();
                        setIsWishlisted(!isWishlisted);
                    }}
                    className="absolute top-2 right-2 w-7 h-7 sm:w-8 sm:h-8 rounded-full flex items-center justify-center bg-white/80 hover:bg-white transition-colors"
                >
                    <Heart
                        className="w-3.5 h-3.5 sm:w-4 sm:h-4"
                        style={{
                            color: isWishlisted ? '#1B4965' : '#6B7280',
                            fill: isWishlisted ? '#1B4965' : 'none'
                        }}
                    />
                </button>

                {/* Quick Add (Desktop hover) */}
                <div className="absolute bottom-0 left-0 right-0 p-3 translate-y-full group-hover:translate-y-0 transition-transform duration-300 hidden md:block">
                    <button
                        onClick={(e) => {
                            e.stopPropagation();
                        }}
                        className="w-full py-2.5 text-xs font-medium tracking-wider uppercase bg-[#1B4965] text-white hover:bg-[#133B53] transition-colors duration-300 flex items-center justify-center gap-2 rounded-sm"
                    >
                        <ShoppingCart className="w-3.5 h-3.5" />
                        Add to Cart
                    </button>
                </div>
            </div>

            {/* Product Info */}
            <div className="p-3 sm:p-4" onClick={() => navigate(`/template4/product/${product.id}`)}>
                <h3 className="text-xs sm:text-sm font-medium text-[#1A1A1A] line-clamp-1 mb-1">
                    {product.name}
                </h3>
                {product.category && (
                    <p className="text-[10px] sm:text-xs text-[#6B7280] mb-1">{product.category}</p>
                )}
                <div className="flex items-center gap-2">
                    <p className="text-xs sm:text-sm font-semibold text-[#1B4965]">
                        {typeof product.price === 'number' ? `\u20B9${product.price.toLocaleString()}` : product.price}
                    </p>
                    {product.originalPrice && (
                        <p className="text-xs text-[#6B7280] line-through">
                            {typeof product.originalPrice === 'number' ? `\u20B9${product.originalPrice.toLocaleString()}` : product.originalPrice}
                        </p>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ProductCard;
